import {
  heroImageFromVinoDataOffer,
  largeHeroImageFromVinoDataOffer,
  roundelsImageFromVinoDataWineOffer,
  wideHeroImageFromVinoDataOffer,
} from "./images";

import { OfferDetailsMixedProps } from "../../components/offer-details";
import { VinoDataOffer } from "../../types/vino-data-types";
import { awardsFromVinoDataWineSKU } from "./awards";
import { isFlagEnabled } from "../../utils/is-flag-enabled";
import { isSellableVinoDataWineSKU } from "./sku";
import { priceDescriptionFromVinoDataOffer } from "../vino-data/price-description";
import { shouldShowDiscountBadge } from "./discount-badge";
import { urgencyMessageFromVinoDataOffer } from "./urgency-message";
import { volumeFromVinoDataSKU } from "./volume";
import { winesFromVinoDataWineSKU } from "../vino-data/wines";

export const offerDetailsMixedPropsFromVinoDataOffer = (
  offer: VinoDataOffer
): OfferDetailsMixedProps => {
  const {
    bigcommerceId,
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    displayFlags,
    region,
    style,
    description,
    videoUrl,
    videoCaption,
    shortDescription,
    sku,
    backgroundColor,
    name,
    bottomDescription,
  } = offer;

  const isSoldOut = !isSellableVinoDataWineSKU(sku);

  return {
    productId: bigcommerceId,
    awards: awardsFromVinoDataWineSKU(sku, 95),
    description,
    videoUrl,
    videoCaption,
    region,
    style,
    discountPercentage,
    discountDollarValue,
    discountDisplay,
    endsAt: offer.endsAt ? new Date(offer.endsAt) : undefined,
    price: offer.displayPrice,
    priceDescription: priceDescriptionFromVinoDataOffer(offer),
    unitRRP: sku?.unitRRP,
    packRRP: sku?.packRRP,
    shortDescription,
    showCountdown:
      isFlagEnabled(offer.displayFlags, "SHOW_COUNTDOWN") &&
      offer.endsAt !== undefined,
    showPriceDrop: isFlagEnabled(displayFlags, "SHOW_PRICEDROP"),
    showDiscountBadge: shouldShowDiscountBadge(offer),
    showAwardBadges: !isFlagEnabled(displayFlags, "HIDE_AWARDS_AND_RATINGS"),
    volume: volumeFromVinoDataSKU(sku),
    wines: winesFromVinoDataWineSKU(sku),
    heroImage: heroImageFromVinoDataOffer(offer),
    roundelsImage: roundelsImageFromVinoDataWineOffer(offer),
    wideHeroImage: wideHeroImageFromVinoDataOffer(offer),
    largeHeroImage: largeHeroImageFromVinoDataOffer(offer),
    urgencyMessage: urgencyMessageFromVinoDataOffer(offer, isSoldOut),
    isSoldOut,
    backgroundColor,
    name,
    bottomDescription,
  };
};
